// atomic.select.v1
//
// Lightweight native-select wrapper for the registry. The codebase has a
// fancy Kobalte-based Select (components/select.tsx) — that's for richer
// in-app menus. For plugin form fields a native <select> is usually
// what we want: native keyboard, native long-list scroll, native search.

import { For, Show, splitProps } from "solid-js"

export interface SelectOption {
  value: string
  label: string
  disabled?: boolean
}

export interface SelectProps {
  value: string
  options: SelectOption[]
  placeholder?: string
  disabled?: boolean
  required?: boolean
  ariaLabel?: string
  name?: string
  id?: string
  onChange?: (value: string) => void
  class?: string
}

export function Select(props: SelectProps) {
  const [local, rest] = splitProps(props, [
    "value",
    "options",
    "placeholder",
    "disabled",
    "required",
    "ariaLabel",
    "name",
    "id",
    "onChange",
    "class",
  ])

  return (
    <select
      data-registry-id="atomic.select"
      value={local.value}
      disabled={local.disabled}
      required={local.required}
      name={local.name}
      id={local.id}
      aria-label={local.ariaLabel}
      onChange={(event) => local.onChange?.(event.currentTarget.value)}
      classList={{
        "h-9 w-full rounded-md border bg-background-base px-2.5 text-14-regular text-text-strong": true,
        "border-border-weak-base focus:outline-none focus:ring-1 focus:ring-border-strong-base": true,
        "disabled:cursor-not-allowed disabled:opacity-50": true,
        [local.class ?? ""]: !!local.class,
      }}
      {...rest}
    >
      <Show when={local.placeholder}>
        <option value="" disabled hidden>
          {local.placeholder}
        </option>
      </Show>
      <For each={local.options}>
        {(option) => (
          <option value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        )}
      </For>
    </select>
  )
}
